import React from "react";
import Navbar from "../../components/Navbar";
import Footer from "../../components/Footer";
import ProduImg from "../../assets/images/products/gov-das.svg"
import HospitalBus from "../../assets/images/products/hospitalBus.png"
import ABHAImg from "../../assets/images/products/abha.png"
import HmisLimsImg from "../../assets/images/products/hmisLmis.png"
import PhrImg from "../../assets/images/products/phr.svg"

const Products=()=>{
    return(
        <> 
            <div className="productPage">
                <Navbar />
                <div className="container">
                    <div className="productHeader">
                        <h1>Comprehensive Health Modules<br />
                        Specialized solutions designed for every <br />stakeholder in the healthcare ecosystem.</h1>
                    </div>
                    <div className="governmentDashboard">
                        <div className="row">
                            <div className="col-xs-12 col-md-6">
                               <div className="govImage">
                                <img src={ProduImg} />
                                </div>
                                <div className="govContent">
                                    <h4>Health Resource Allocation</h4>
                                    <p>Displays availability of beds, equipment, doctors, and supplies and predicts future needs.</p>
                                </div> 
                                <div className="govContent">
                                    <h4>Policy & Governance Compliance</h4>
                                    <p>Shows performance against national guidelines and highlights non-compliant areas.</p>
                                </div> 
                            </div>
                            <div className="col-xs-12 col-md-6">
                                <div className="govHeader"><h4>Government Dashboard</h4></div>
                                <div className="govContent">
                                    <h4>Real-time Disease Surveillance & <br />Trend Analytics</h4>
                                    <p>Tracks outbreaks, trends and hotspots with live data feeds across districts and states.</p>
                                </div> 
                                <div className="govContent">
                                    <h4>Maternal & Child Health, Nutrition & Malnutrition Monitoring </h4>
                                    <p>Monitors key indicators like ANC, PNC, immunization, nutrition and malnutrition levels. </p>
                                </div> 
                                <div className="govContent">
                                    <h4>AI-Driven Public Health Insights</h4>
                                    <p>Generates actionable recommendations for prevention, planning, and resource distribution.</p>
                                </div> 
                            </div>
                        </div>
                    </div>


                    <div className="hospitalBusApp">
                        <div className="container">
                            <div className="hospitalBusAppMain">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govHeader"><h4>Hospital Business App</h4></div>
                                        <div className="govContent">
                                            <h4>Doctor & Appointment Management</h4>
                                            <p>Easily manage schedules, departments, daily slots, and patient flows.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>AI Insights on Patient & Disease <br />Trends</h4>
                                            <p>Predicts patient load, top diseases, and medication requirements using analytics. </p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Role-Based Access Control</h4>
                                            <p>Secure access for admins, doctors, nurses, lab staff, and support teams.</p>
                                        </div> 
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govImage">
                                            <img src={HospitalBus} />
                                        </div>
                                        <div className="govContent">
                                            <h4>Revenue & Insurance Tracking</h4>
                                            <p>Monitors billing, payments, claims, and outstanding insurance reimbursements.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Operational Metrics & Utilization</h4>
                                            <p>Real-time view of beds, OTs, wards, equipment usage, and service efficiency.</p>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>


                    
                    <div className="abhaSection">
                        <div className="container">
                            <div className="abhaMain">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govImage">
                                            <img src={ABHAImg} />
                                        </div>
                                        <div className="govContent">
                                            <h4>Seamless ABDM Ecosystem Integration</h4>
                                            <p>Compatible with national health standards and digital health workflows.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Faster Patient Onboarding</h4>
                                            <p>Reduces paperwork and accelerates admission and consultation processes.</p>
                                        </div> 
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govHeader"><h4>ABHA</h4></div>
                                        <div className="govContent">
                                            <h4>Digital Health ID Creation & <br />Verification</h4>
                                            <p>Monitors billing, payments, claims, and outstanding insurance reimbursements.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Revenue & Insurance Tracking</h4>
                                            <p>Monitors billing, payments, claims, and outstanding insurance reimbursements.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Consent-Based Data Sharing</h4>
                                            <p>Allows patients to approve data access, ensuring privacy and security.</p>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>



                     <div className="hmisLmisSection">
                        <div className="container">
                            <div className="hmisLmisMain">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govImage">
                                            <img src={HmisLimsImg} />
                                        </div>
                                        <div className="govContent">
                                            <h4>AI Electronic Medical Records</h4>
                                            <p>Keeps patient history, prescriptions, test reports, and clinical notes in one system.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Test Volume & TAT Analytics</h4>
                                            <p>Provides insights into turnaround time, utilization, and abnormal results.</p>
                                        </div> 
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govHeader"><h4>HMIS / LIMS</h4></div>
                                        <div className="govContent">
                                            <h4>Complete Lab & Radiology Workflow</h4>
                                            <p>AI test ordering, sample collection, AI processing, and AI reporting end-to-end.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>AI Sample Tracking & Quality <br />Control </h4>
                                            <p>Barcode tracking ensures accuracy and reduces sample handling errors. </p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Automated Billing & Claim Sync</h4>
                                            <p>Automatically adds lab charges and syncs with hospital billing and insurance.</p>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                    <div className="phrSection">
                        <div className="container">
                            <div className="phrMain">
                                <div className="row">
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govHeader"><h4>PHR</h4></div>
                                        <div className="govContent">
                                            <h4> Unified Health Record Storage</h4>
                                            <p>Keeps all medical files—prescriptions, labs, scans, and summaries—in one secure app.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Appointments, Bills & Insurance <br />Tracking </h4>
                                            <p>Manages visits, digital receipts, claims, and medication reminders in one place. </p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>ABHA-Linked Digital Health Profile</h4>
                                            <p>Automatically syncs and updates data from hospitals through ABDM standards.</p>
                                        </div> 
                                    </div>
                                    <div className="col-xs-12 col-md-6">
                                        <div className="govImage">
                                            <img src={PhrImg} />
                                        </div>
                                        <div className="govContent">
                                            <h4>Smart Health Timeline</h4>
                                            <p>Organizes health events chronologically and highlights important patterns.</p>
                                        </div> 
                                        <div className="govContent">
                                            <h4>Secure Consent-Based Sharing</h4>
                                            <p>Users control who accesses their data—doctors, labs, insurers—with full transparency.</p>
                                        </div> 
                                    </div>
                                </div>
                            </div>
                        </div>
                    </div>




                </div>
            </div>
            <Footer />
        </>
    )
}   

export default Products;